// Actiondan gelen datalar ile stateler güncellenecek
export const ticketLoading = (state, payload) => {
  state.loading = payload
}

export const ticketStatus = (state, payload) => {
  state.ticketStatus = payload
}

export const setTickets = (state, payload) => {
  state.tickets = payload.data ? payload.data : []
  state.ticketPageInfo = payload.list_info

}

export const setTicket = (state, payload) => {
  state.ticket = payload.data
}

export const setTicketPageInfo = (state, payload) => {
  state.ticketPageInfo = payload
}

export const setTicketComments = (state, payload) => {
  state.ticketComments = payload.data ? payload.data : payload
  state.commentPageInfo = payload.list_info

}

export const setCustomerProducts = (state, payload) => {
  state.customerProducts = payload.data ? payload.data : []
}




// WEBPACK FOOTER //
// ./src/store/modules/Ticket/Mutations.js